export default 0;



// WEBPACK FOOTER //
// ./src/api/delay.js